














import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import StButton from '@/components/basic/StButton.vue';

@Component({
  components: {
    StButton,
  },
})
export default class StSelectButton extends Vue {
  @Prop() options!: { text: string; value: string; icon: string }[];
  @Prop() value!: string;

  @Emit('input')
  input(value: string) {
    return value;
  }
}
